export class ModelEditService {    
  DPI = {
  requiredFields: ['penetrantType', 'penetrantDwellTime', 'developerType', 'developerDwellTime']
  }
}
